<template>
	<v-app theme="light" style="background-color: #eeeeee">
		<nav-bar-emissions />
		<VMain class="emissions-results-main">
			<breadcrumbs />
			<v-container class="emissions-results-container">
				<!-- <v-row class="contentRow">
					<v-col align="left">
						<v-btn width="100%" class="mx-auto" color="primary" to="/emissions/suppliers">
							<v-icon left>fas fa-user-friends</v-icon>See your Suppliers' Score
						</v-btn>
					</v-col>
				</v-row> -->
				<v-row class="contentRow">
					<v-col align="center" style="position: relative">
						<h1>
							{{ $store.getters["user/getUser"].clientName }}'s CO₂ Emission Results {{this.currentyear }}
						</h1>
						</v-col>
				</v-row>
				<v-row class="contentRow" style="position: relative">
					<v-col align="end" style="position: relative">
				
						
						<v-btn
							v-if="showFillOutButton"
							class="yourscorebtn1"
							style="color: white; background-color: orange"
							elevation="0"
							exact
							@click="goToSuppliers"
						>
							Fillout for {{ fillOutYear }}
						</v-btn>
					</v-col>
				</v-row>
				<v-row v-if="resultsLoaded" class="contentRow">
					<supplier-emissions
						:key="totalEmission"
						:title="`Your carbon emission results:`"
						:emissionEnergy="emissionEnergy"
						:emissionBusinessTrips="emissionBusinessTrips"
						:emissionIngoingShipping="emissionIngoingShipping"
						:emissionOutgoingShipping="emissionOutgoingShipping"
						:emissionCompanyOrganization="emissionCompanyOrganization"
						:emissionPackaging="emissionPackaging || 0"
						:totalEmission="totalEmission"
					/>
				</v-row>
				<div class="emission-badge-canvas" aria-hidden="true">
					<canvas width="600" height="600" ref="canvas" />
				</div>

				<v-row class="contentRow emissions-key-indicators-row">
					<v-col cols="12">
				<h1 class="font-weight-bold basil--text px-4 text-left">
							Key Indicators
						</h1>
					</v-col>
					<v-col align="center" cols="12">
						<div id="app">
							<KeyIndicators :data="indicators" />
						</div>
					</v-col>
				</v-row>
				<v-row class="contentRow justify-center">
					<v-col cols="12" md="6">
						<v-card class="pa-6 text-center elevation-3 rounded-lg" outlined>
							<v-card-title class="text-h5 font-weight-bold title-enhanced">
								Download Your <span class="highlight">Emission Badge</span>
							</v-card-title>
							<v-card-text>
								<v-img max-width="140" class="mx-auto my-4 badge-image"
									:src="require('../assets/emission-badge-2025.png')" />
								<p class="text-subtitle-1 text-gray-dark">
									Show your commitment to sustainability by downloading your emission badge.
								</p>
							</v-card-text>
							<v-card-actions class="justify-center">
								<v-btn class="download-btn" color="success" large @click="downloadCanvas">
									<v-icon left>fas fa-download</v-icon> Download Badge
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
				<v-row class="contentRow">
					<v-col align="center" cols="12">
						<v-card color="basil">
							<v-card-title class="py-6">
								<h2 class="font-weight-bold basil--text">
									Scope-Wise Emission
								</h2>
							</v-card-title>

							<v-tabs v-model="tab" background-color="transparent" light icons-and-text>
								<v-tab>
									<v-icon style="margin-top: 10px;" left>fas fa-table</v-icon>
									Table Data
								</v-tab>
								<v-tab>
									<v-icon style="margin-top: 10px;" left>fas fa-chart-bar</v-icon>
									Chart Analysis
								</v-tab>
								<v-tab>
									<v-icon style="margin-top: 10px;" left>fas fa-info-circle</v-icon>
									Scope Overview
								</v-tab>
							</v-tabs>

							<!-- Tabs Content -->
							<v-tabs-items v-model="tab">
								<!-- Table Data -->
								<v-tab-item>
									<v-card color="basil" flat>
										<v-card-text>
											<emission-table :headers="headers"
												:formatted-table-data="formattedScopeData" />
										</v-card-text>
									</v-card>
								</v-tab-item>

								<!-- Chart Analysis -->
								<v-tab-item>
									<v-card color="basil" flat>
										<v-card-text>
											<EmissionDualAxisChart :data="chartData" />
										</v-card-text>
									</v-card>
								</v-tab-item>

								<!-- New Scope Overview Tab -->
								<v-tab-item>
									<v-card color="basil" flat>
										<v-card-text>
											<v-row justify="center">
												<v-col cols="12" md="4">
													<v-card class="pa-4" elevation="4" style="height: 500px;">
														<v-card-title class="d-flex justify-center"
															style="margin-top:20px">
															<v-icon size="50" color="primary" class="text-center">fas
																fa-industry</v-icon>
														</v-card-title>
														<v-card-subtitle class="text-center font-weight-bold text-h6">
															SCOPE 1: Direct Emissions
														</v-card-subtitle>
														<v-card-text style="text-align: justify;">
															<p><strong>Definition:</strong> Emissions from sources a
																company owns or controls, including fuel combustion and
																process emissions.</p>
															<p><strong>Examples:</strong></p>
															<ul>
																<li>Burning diesel in company trucks</li>
																<li>On-site boilers and generators</li>
																<li>Fugitive emissions (e.g., refrigerant leaks)
																
																
																</li>
															</ul>

														</v-card-text>
													</v-card>
												</v-col>
												<!-- Scope 2 -->
												<v-col cols="12" md="4">
													<v-card class="pa-4" elevation="4" style="height: 500px;">
														<v-card-title>
															<v-container>
																<v-row justify="center">
																	<v-col cols="auto">
																		<v-icon size="50" color="warning">fas fa-bolt</v-icon>
																	</v-col>
																</v-row>
															</v-container>
														</v-card-title>
														<v-card-subtitle class="text-center font-weight-bold text-h6">
															SCOPE 2: Indirect Energy Emissions
														</v-card-subtitle>
														<v-card-text style="text-align: justify;">
															<p><strong>Definition:</strong> Emissions from the
																generation of purchased energy (electricity, steam,
																heating, or cooling) consumed by the company.</p>
															<p><strong>Examples:</strong></p>
															<ul>
																<li>Electricity used in office buildings</li>
																<li>Purchased steam or heating for industrial processes

																</li>
															</ul>
														</v-card-text>
													</v-card>
												</v-col>
												<!-- Scope 3 -->
												<v-col cols="12" md="4">
													<v-card class="pa-4" elevation="4" style="min-height: 500px;">
														<v-card-title>
															<v-container>
																<v-row justify="center">
																	<v-col cols="auto">
																		<v-icon size="50" color="success">fas
																			fa-plane</v-icon>
																	</v-col>
																</v-row>
															</v-container>
														</v-card-title>
														<v-card-subtitle class="text-center font-weight-bold text-h6">
															SCOPE 3: Value Chain Emissions
														</v-card-subtitle>
														<v-card-text style="text-align: justify;">
															<p><strong>Definition:</strong> All other indirect emissions
																in a company’s value chain, including supply chain,
																travel, packaging and waste disposal.</p>
															<p><strong>Examples:</strong></p>
															<ul>
																<li>Production of purchased goods and services</li>
																<li>Business travel and employee commuting</li>
																<li>Waste generated in operations</li> 
																<li>Purchased packaging materials and end-of-life treatment</li>
															</ul>
														</v-card-text>
													</v-card>
												</v-col>

											</v-row>
										</v-card-text>
										<v-col cols="12">
											<v-card class="pa-4" elevation="4" style="height: 280px;">
												<v-card-title class="d-flex justify-center">
													<h3 class="font-weight-bold">Data Sources</h3>
												</v-card-title>
												<v-card-text class="text-center">
													<p>These resources provided standardized emission factors and
														methodological guidance essential for calculating accurate
														carbon footprints across all three scopes of emissions.The
														emission factors and methodology data used in this analysis were
														extracted from the following authoritative sources:</p>
													<v-row justify="center" class="mt-4">
														<v-col cols="12" md="4">
															<v-card outlined>
																<v-card-title class="justify-center">
																	<v-icon color="primary" class="mr-2">fas
																		fa-leaf</v-icon>
																	NEA
																</v-card-title>
																<v-card-subtitle class="text-center">
																	<a href="https://www.environmentagency.no/" target="_blank">environmentagency.no</a>
																</v-card-subtitle>
															</v-card>
														</v-col>
														<v-col cols="12" md="4">
															<v-card outlined>
																<v-card-title class="justify-center">
																	<v-icon color="success" class="mr-2">fas
																		fa-building</v-icon>
																	DEFRA
																</v-card-title>
																<v-card-subtitle class="text-center">
																	<a href="https://www.gov.uk/" target="_blank">gov.uk</a>
																</v-card-subtitle>
															</v-card>
														</v-col>
														<v-col cols="12" md="4">
															<v-card outlined>
																<v-card-title class="justify-center">
																	<v-icon color="warning" class="mr-2">fas fa-file-alt</v-icon>
																	GHG Protocol
																</v-card-title>
																<v-card-subtitle class="text-center">
																	<a href="https://ghgprotocol.org/" target="_blank">ghgprotocol.org</a>
																</v-card-subtitle>
															</v-card>
														</v-col>
													</v-row>

												</v-card-text>
											</v-card>
										</v-col>
									</v-card>
								</v-tab-item>
							</v-tabs-items>
						</v-card>
					</v-col>
				</v-row>
				<v-row class="contentRow">
					<v-col align="center" cols="12">
						<emission-pie-charts :chartData="pieChartData" />
					</v-col>
				</v-row>
				<v-row class="contentRow" no-gutters>
					<v-col align="center" cols="12" class="full-width">
						<emission-table :headers="headers" :formatted-table-data="formattedTableData" />
					</v-col>
					<v-col align="left" cols="12">
						<v-btn width="30%" class="mx-auto" color="success" @click="showdata= !showdata"
							style="margin-bottom: 20px; margin-top: 20px;">
							<v-icon left>fas fa-eye</v-icon>View Detailed Emission Data
						</v-btn>
					</v-col>
				</v-row>

				<v-row v-if="showdata" class="contentRow">

					<v-col align="right" cols="12">
						<v-btn width="20%" class="mx-auto" color="success" @click="downloadAnswers">
							<v-icon left>fas fa-download</v-icon>Download PDF
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
			<v-container v-if="showdata && answers && questions" class="emissions-results-container">
				<div v-for="(question, index) in questions" :key="index">
					<template v-if="shouldShowDetailedRow(index)">
						<v-row class="my-13" v-if="question.type == 'spacer'"></v-row>
						<v-row
							v-else-if="question.type == 'title' && index != 0"
							class="contentRow primary"
							:style="titleStyle(question)"
						>
							<v-col cols="12" class="white--text">
								<h2>{{ question.name }}</h2>
							</v-col>
						</v-row>
						<v-row
							v-else-if="question.type != 'title' && question.type != 'spacer'"
							class="contentRow"
							no-gutters
						>
							<v-col>
								<h4 class="primary--text">{{ question.name }}</h4>
								<br />
								<p>{{ formatDetailedAnswer(index) }}</p>
							</v-col>
						</v-row>
					</template>

					<template v-if="index === 22 && usesDistributionPartners()">
						<v-row class="contentRow primary" :style="titleStyle({ color: 'rgb(30,154,116)' })">
							<v-col cols="12" class="white--text">
								<h2>Part 3: Ingoing &amp; Outgoing Shipping</h2>
							</v-col>
						</v-row>
						<v-row class="contentRow" no-gutters>
							<v-col>
								<h4 class="primary--text">Do you have Reports from Distribution Partners?</h4>
								<br />
								<p>Yes</p>
							</v-col>
						</v-row>
						<v-row
							v-for="(partner, pIndex) in emission.partners.distributionPartners"
							:key="`partner-${pIndex}`"
							class="contentRow"
							no-gutters
						>
							<v-col>
								<h4 class="primary--text">{{ partner.company || `Partner ${pIndex + 1}` }}</h4>
								<br />
								<p>CO₂ emission: {{ formatDetailedValue(partner.co2Emission) }} kg</p>
							</v-col>
						</v-row>
						<v-row class="contentRow" no-gutters>
							<v-col>
								<h4 class="primary--text">What percentage of the facility's total shipments are outgoing shipping?</h4>
								<br />
								<p>{{ formatDetailedValue(emission.partners.percentage) }}%</p>
							</v-col>
						</v-row>
					</template>

					<template v-if="index === 50 && answers[48] === 'Yes'">
						<v-row class="contentRow" no-gutters>
							<v-col>
								<h3 class="primary--text">Packaging materials used annually</h3>
							</v-col>
						</v-row>
						<v-row
							v-for="materialRow in detailedPackagingMaterials"
							:key="materialRow.material"
							class="contentRow"
							no-gutters
						>
							<v-col>
								<h4 class="primary--text">{{ materialRow.material }}</h4>
								<br />
								<p>{{ materialRow.display }}</p>
							</v-col>
						</v-row>
						<v-row v-if="detailedPackagingMaterials.length === 0" class="contentRow" no-gutters>
							<v-col>
								<h4 class="primary--text">Packaging materials</h4>
								<br />
								<p>-</p>
							</v-col>
						</v-row>
					</template>
				</div>
			</v-container>
			<div class="emission-badge-canvas" aria-hidden="true">
				<canvas width="600" height="600" ref="canvas" />
			</div>
			<orixe-footer />
		</VMain>
	</v-app>
</template>
<script>
import Chart from "chart.js"
import LoadingState from "../consts/LoadingState"
import EmissionsApi from "../api/emissions/emissions"
import SupplierEmissions from "../components/SupplierEmissions.vue"
import domtoimage from "dom-to-image"
import KeyIndicators from "../components/EmissionIndicators.vue"
import EmissionTable from "../components/EmissionTable.vue"
import EmissionDualAxisChart from "../components/EmissionDualAxisChart.vue"
import EmissionPieCharts from "../components/EmissionPieCharts.vue"
import { calculatePackagingEmission, getPackagingRowWeightKg } from "../utils/packagingEmission"
export default {
	name: "Emission-Results",
	components: {
		"supplier-emissions": SupplierEmissions,
		KeyIndicators,
		EmissionTable,
		EmissionDualAxisChart,
		EmissionPieCharts,
	},

	data() {
		return {
			id: null,
			formId: null,
			name: null,
			emission: null,
			showdata: false,
			timestamp: null,
			answers: null,
			emissionEnergy: null,
			emissionBusinessTrips: null,
			emissionIngoingShipping: null,
			emissionOutgoingShipping: null,
			emissionCompanyOrganization: null,
			emissionPackaging: null,
			totalEmission: null,
			resultsLoaded: false,
			indicators:[],
			questions: null,
			newtimestamp: null,
			currentyear:null,
			tab: null,
			items: ["Table", "Diagram"],
			headers: [
				{ text: "Category", align: "start", value: "category", width: "65%", sortable: false },
				{ text: "2023", value: "2023" , sortable: false},
				{ text: "2024", value: "2024" , sortable: false},
				{ text: "2025", value: "2025" , sortable: false},
			],
			formattedScopeData: [{ category: "Scope 1 - direct emissions​", isCategory: true , isTotal2: true }, ],
			chartData: {},
			formattedTableData: [{category:"Energy Consumption",isCategory:true,isTotal1:true}],
			pieChartData: {
				labels: [ "Business Trips", "Energy Consumption", "Facility Organization", "Shipping Incoming", "Shipping Outgoing","packaging", ],
				backgroundColor: ["#cd1c42", "#e9891b", "#6772bc", "#1e9a74", "#388e3c","#8e24aa",],
				datasets: [{
					labels: ["2022", "2023", "2024"],
					data: [ [30, 25, 10, 25, 10], [30, 25, 10, 25, 10], [30, 25, 10, 25, 10], ],
				}],
			},

		}
	},
	mounted() {
		this.id = parseInt(this.$route.params.id)
		this.loadEmissionsForm()
		this.loadResult()

	},
	computed: {
		fillOutYear() {
			return new Date().getFullYear()
		},
		showFillOutButton() {
			if (!this.newtimestamp) {
				return false
			}
			const latestSubmissionYear = this.getYearFromTimestamp(this.newtimestamp)
			if (latestSubmissionYear == null) {
				return false
			}
			return latestSubmissionYear < this.fillOutYear
		},
		detailedPackagingMaterials() {
			const packaging = this.parsePackaging({ answers: this.answers })
			if (!packaging?.materials?.length) {
				return []
			}
			return packaging.materials.map((row) => ({
				material: row.material,
				display: this.formatPackagingMaterialDetail(row, packaging),
			}))
		},
	},
	methods: {
		getYearFromTimestamp(timestamp) {
			if (timestamp == null) return null
			const ts = String(timestamp).length === 10 ? Number(timestamp) * 1000 : Number(timestamp)
			return new Date(ts).getFullYear()
		},
		getResultForYear(result, year) {
			if (year == null) return null
			return result.find((r) => this.getYearFromTimestamp(r?.timestamp) === year) || null
		},
		resolveDisplayTotals(record) {
			const categoryTotals = this.resolveCategoryTotals(record)
			if (categoryTotals.length >= 6) {
				const energy = Math.round(categoryTotals[0] ?? 0)
				const businessTrips = Math.round(categoryTotals[1] ?? 0)
				const ingoingShipping = Math.round(categoryTotals[2] ?? 0)
				const outgoingShipping = Math.round(categoryTotals[3] ?? 0)
				const facilityOrganization = Math.round(categoryTotals[4] ?? 0)
				const packaging = Math.round(categoryTotals[5] ?? 0)
				return {
					energy,
					businessTrips,
					ingoingShipping,
					outgoingShipping,
					facilityOrganization,
					packaging,
					total: energy + businessTrips + ingoingShipping + outgoingShipping + facilityOrganization + packaging,
				}
			}

			const packaging = Math.round(calculatePackagingEmission(this.parsePackaging(record)) || 0)
			const facilityOrganization = Math.round(Math.max(0, (categoryTotals[4] ?? 0) - packaging))
			const energy = Math.round(categoryTotals[0] ?? 0)
			const businessTrips = Math.round(categoryTotals[1] ?? 0)
			const ingoingShipping = Math.round(categoryTotals[2] ?? 0)
			const outgoingShipping = Math.round(categoryTotals[3] ?? 0)
			const total = energy + businessTrips + ingoingShipping + outgoingShipping + facilityOrganization + packaging

			return {
				energy,
				businessTrips,
				ingoingShipping,
				outgoingShipping,
				facilityOrganization,
				packaging,
				total,
			}
		},
		resolveCategoryTotals(record) {
			const totals = (record?.totalEmission || []).map((value) => Number(value) || 0)
			if (totals.reduce((sum, value) => sum + value, 0) > 0) {
				return totals
			}
			const scope = record?.scopecalculateEmission
			if (!scope) return totals
			const s1 = scope.scope1 || []
			const s2 = scope.scope2 || []
			const s3 = scope.scope3 || []
			return [
				s2[0] || 0,
				(s1[0] || 0) + (s3[5] || 0),
				s3[3] || 0,
				s3[8] || 0,
				s3[4] || 0,
				s3[6] || 0
			]
		},
		sumAllScopes(scope) {
			const sum = (arr) => (arr || []).reduce((total, value) => total + (Number(value) || 0), 0)
			return sum(scope?.scope1) + sum(scope?.scope2) + sum(scope?.scope3)
		},
		formatCellValue(value) {
			if (value === 0 || value === "0") return 0
			if (value == null || value === "") return "-"
			return value
		},
		parseNumericAnswer(answer, fallback = 1) {
			const parsed = parseFloat(answer)
			return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
		},
		parsePackaging(record) {
			if (record?.answers?.[48] !== "Yes") {
				return null
			}
			let materials = []
			const rawMaterials = record?.answers?.[51]
			if (rawMaterials) {
				try {
					materials = typeof rawMaterials === "string" ? JSON.parse(rawMaterials) : rawMaterials
					if (!Array.isArray(materials)) {
						materials = []
					}
				} catch (err) {
					materials = []
				}
			}
			return {
				weightEntryMethod: record.answers[49] || "Total weight per material (kg/year)",
				defaultEndOfLife: record.answers[50] || "Mostly landfilled",
				materials,
			}
		},
		getPackagingWeightDisplay(packaging, row) {
			if (!packaging || !row) return "-"
			const totalWeightKg = getPackagingRowWeightKg(row, packaging.weightEntryMethod)
			return totalWeightKg > 0 ? `${totalWeightKg.toFixed(2)} kg` : "-"
		},
		buildPackagingTableRows(result, years, yearHeaderValues) {
			const materialNames = ["Cardboard", "PET", "HDPE", "LDPE", "PP", "PVC/Other", "Glass", "Aluminum"]
			const rows = [
				{
					category: this.questions?.[47]?.name || "Part 5: Packaging",
					isCategory: true,
					isTotal6: true,
				},
				{
					category: `• ${this.questions?.[48]?.name || "Do you use packaging materials?"}`,
					...Object.fromEntries(years.map((year) => [
						yearHeaderValues[year],
						this.formatCellValue(this.getResultForYear(result, year)?.answers?.[48]),
					])),
				},
				{
					category: `• ${this.questions?.[49]?.name || "How do you want to report packaging weight?"}`,
					...Object.fromEntries(years.map((year) => [
						yearHeaderValues[year],
						this.formatCellValue(this.getResultForYear(result, year)?.answers?.[49]),
					])),
				},
				{
					category: `• ${this.questions?.[50]?.name || "Default end-of-life treatment"}`,
					...Object.fromEntries(years.map((year) => [
						yearHeaderValues[year],
						this.formatCellValue(this.getResultForYear(result, year)?.answers?.[50]),
					])),
				},
			]

			for (const material of materialNames) {
				rows.push({
					category: `• ${material}`,
					...Object.fromEntries(years.map((year) => {
						const record = this.getResultForYear(result, year)
						const packaging = this.parsePackaging(record)
						const row = packaging?.materials?.find((item) => item.material === material)
						if (!row) return [yearHeaderValues[year], "-"]
						const weight = this.getPackagingWeightDisplay(packaging, row)
						const e1 = row.recycledContentPct !== "" && row.recycledContentPct != null ? `${row.recycledContentPct}%` : "-"
						const e2 = row.recycledAfterUsePct !== "" && row.recycledAfterUsePct != null ? `${row.recycledAfterUsePct}%` : "-"
						const eol = row.endOfLife || packaging.defaultEndOfLife || "-"
						return [yearHeaderValues[year], weight === "-" ? "-" : `${weight}; E1:${e1}; E2:${e2}; EOL:${eol}`]
					})),
				})
			}

			rows.push({
				category: "Total CO2 Emission from Packaging",
				...Object.fromEntries(years.map((year) => {
					const packaging = this.parsePackaging(this.getResultForYear(result, year))
					const value = calculatePackagingEmission(packaging)
					return [yearHeaderValues[year], this.formatCellValue(Number(value.toFixed(2)))]
				})),
				isTotal: true,
			})

			return rows
		},
		loadEmissionsForm() {
			EmissionsApi.getEmissionsForm()
				.then((data) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{
							root: true,
						}
					)
					this.name = data[1].name
					this.formId = data[1].id
					this.$set(this, "questions", data[1].questions)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadResult() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			EmissionsApi.getResult(this.id)
				.then((result) => {
					if (!result || !result.length) {
						return
					}
					this.id = result[0].id
					this.emission = result[0]
					const displayTotals = this.resolveDisplayTotals(result[0])
					this.emissionEnergy = displayTotals.energy
					this.emissionBusinessTrips = displayTotals.businessTrips
					this.emissionIngoingShipping = displayTotals.ingoingShipping
					this.emissionOutgoingShipping = displayTotals.outgoingShipping
					this.emissionCompanyOrganization = displayTotals.facilityOrganization
					this.emissionPackaging = displayTotals.packaging
					this.answers = result[0].answers
					this.newtimestamp = result[0].timestamp
					this.totalEmission = displayTotals.total
					this.resultsLoaded = true
					const revenue = this.parseNumericAnswer(result[0].answers[40], 1)
					const wemployees = this.parseNumericAnswer(result[0].answers[43], 1)

					this.indicators = [
						Math.round((this.totalEmission / revenue) * 1000000),
						Math.round(this.totalEmission / wemployees),
						Math.ceil((this.totalEmission / 1000) * 50)
					]

					let years = result
						.map((r) => {
							if (!r || r.timestamp == null) return null
							let ts = String(r.timestamp).length === 10 ? Number(r.timestamp) * 1000  : Number(r.timestamp)
							return new Date(ts).getFullYear()
						})
						.filter((year) => year != null)
						.slice(0, 3)

					this.currentyear = years[0]


					// Build the object array per index
					let objectArray = result.map((r) => {
						if (!r || r.timestamp == null) return null

						let ts = String(r.timestamp).length === 10 ? Number(r.timestamp) * 1000 : Number(r.timestamp)
						let year = new Date(ts).getFullYear()

						return {
							year: year,
							mobileCombustion: +(r.scopecalculateEmission?.scope1?.[0] ?? 0).toFixed(2),
							purchasedEnergy: +(r.scopecalculateEmission?.scope2?.[0] ?? 0).toFixed(2),
							upstreamTransportationAndDistribution: +(r.scopecalculateEmission?.scope3?.[3] ?? 0).toFixed(2),
							wasteGeneratedInOperations: +(r.scopecalculateEmission?.scope3?.[4] ?? 0).toFixed(2),
							businessTravel: +(r.scopecalculateEmission?.scope3?.[5] ?? 0).toFixed(2),
							downstreamTransportationAndDistribution: +(r.scopecalculateEmission?.scope3?.[8] ?? 0).toFixed(2),
							purchasedGoodsPackaging: +(r.scopecalculateEmission?.scope3?.[6] ?? 0).toFixed(2)
						}
					}).filter(item => item !== null) // Remove null values

					let objectArray2 = result.map((r) => {
						if (!r || r.timestamp == null) return null

						let ts = String(r.timestamp).length === 10 ? Number(r.timestamp) * 1000 : Number(r.timestamp)
						let year = new Date(ts).getFullYear()
						const displayTotals = this.resolveDisplayTotals(r)
						let total = displayTotals.total
						
						return {
							year: year,
							e1: total > 0 ? Math.round((displayTotals.energy / total) * 100) : 0,
							e2: total > 0 ? Math.round((displayTotals.businessTrips / total) * 100) : 0,
							e3: total > 0 ? Math.round((displayTotals.ingoingShipping / total) * 100) : 0,
							e4: total > 0 ? Math.round((displayTotals.outgoingShipping / total) * 100) : 0,
							e5: total > 0 ? Math.round((displayTotals.facilityOrganization / total) * 100) : 0,
							e6: total > 0 ? Math.round((displayTotals.packaging / total) * 100) : 0,
							total: total.toFixed(2)
						}
					}).filter(item => item !== null) // Remove null values

					
					objectArray2.sort((a, b) => b.year - a.year)

					// Transform your objectArray2 into the pieChartData format
					this.pieChartData = {
						labels: [ "Energy Consumption", "Business Trips", "Shipping Incoming", "Shipping Outgoing", "Facility Organization", "Packaging" ],
						backgroundColor: ["#e9891b", "#cd1c42", "#1e9a74", "#388e3c", "#6772bc", "#8e24aa"],
						datasets: [{
							labels: objectArray2.map(obj => obj.year.toString()),
							data: [ objectArray2.map(obj => [obj.e1, obj.e2, obj.e3, obj.e4, obj.e5, obj.e6]), ].flat(), // Flatten the array of arrays
							total: objectArray2.map(obj => parseFloat(obj.total))
						}]
					}

					this.headers = [
						{ text: "Category", align: "start", value: "category", width: "65%", sortable: false },
						...years.map((year, index) => ({ text: String(year), value: `year_${year}_${index}`, sortable: false }))
					]
					const yearHeaderValues = Object.fromEntries(
						years.map((year, index) => [year, `year_${year}_${index}`])
					)

					let totalScope3 = Object.fromEntries(years.map(year => {
						let obj = objectArray.find(obj => obj.year === year) || {}
						let sum = (obj.upstreamTransportationAndDistribution || 0) +
							(obj.wasteGeneratedInOperations || 0) +
							(obj.businessTravel || 0) +
							(obj.downstreamTransportationAndDistribution || 0) +
							(obj.purchasedGoodsPackaging || 0)
						return [yearHeaderValues[year], +sum.toFixed(2)]
					}))

					let grandTotal = Object.fromEntries(years.map((year) => {
						const record = this.getResultForYear(result, year)
						let total = this.resolveCategoryTotals(record).reduce((sum, value) => sum + (Number(value) || 0), 0)
						if (total === 0 && record?.scopecalculateEmission) {
							total = this.sumAllScopes(record.scopecalculateEmission)
						}
						return [yearHeaderValues[year], +total.toFixed(2)]
					}))
					let grandTotalByYear = Object.fromEntries(years.map((year) => {
						const record = this.getResultForYear(result, year)
						let total = this.resolveCategoryTotals(record).reduce((sum, value) => sum + (Number(value) || 0), 0)
						if (total === 0 && record?.scopecalculateEmission) {
							total = this.sumAllScopes(record.scopecalculateEmission)
						}
						return [year, +total.toFixed(2)]
					}))
					let co2PerEmployee = Object.fromEntries(years.map((year) => {
						const record = this.getResultForYear(result, year)
						const employeeCount = this.parseNumericAnswer(record?.answers?.[43], 1)
						let value = Math.round((grandTotalByYear[year] || 0) / employeeCount)
						return [yearHeaderValues[year], +value.toFixed(2)]
					}))

					let co2PerRevenue = Object.fromEntries(years.map((year) => {
						const record = this.getResultForYear(result, year)
						const revenue = this.parseNumericAnswer(record?.answers?.[40], 1)
						let value = ((grandTotalByYear[year] || 0) / revenue) * 1000000
						return [yearHeaderValues[year], Number.isFinite(value) ? +value.toFixed(2) : "-"]
					}))

					const labels = [...years].sort((a, b) => b - a)
					const scope1 = labels.map(year => objectArray.find(obj => obj.year === year)?.mobileCombustion ?? 0)
					const scope2 = labels.map(year => objectArray.find(obj => obj.year === year)?.purchasedEnergy ?? 0)
					const scope3 = labels.map(year => {
						const obj = objectArray.find(item => item.year === year) || {}
						return +(
							(obj.upstreamTransportationAndDistribution || 0) +
							(obj.wasteGeneratedInOperations || 0) +
							(obj.businessTravel || 0) +
							(obj.downstreamTransportationAndDistribution || 0) +
							(obj.purchasedGoodsPackaging || 0)
						).toFixed(2)
					})
					const employeeList = labels.map(year => {
						const record = this.getResultForYear(result, year)
						return this.parseNumericAnswer(record?.answers?.[43], 0)
					})
					this.chartData = { labels, scope1, scope2, scope3, employees: employeeList }

					this.formattedScopeData = [
						{ category: "Scope 1 - direct emissions​", isCategory: true, isTotal2: true },
						{ category: "• Mobile Combustion​", ...Object.fromEntries(years.map(year => [yearHeaderValues[year], this.formatCellValue(objectArray.find(obj => obj.year === year)?.mobileCombustion ?? 0)])) },
						{ category: "Total emissions Scope 1", ...Object.fromEntries(years.map(year => [yearHeaderValues[year], this.formatCellValue(objectArray.find(obj => obj.year === year)?.mobileCombustion ?? 0)])), isTotal: true },

						{ category: "Scope 2 - indirect emissions for own use​", isCategory: true, isTotal1: true },
						{ category: "• Purchased Energy​", ...Object.fromEntries(years.map(year => [yearHeaderValues[year], this.formatCellValue(objectArray.find(obj => obj.year === year)?.purchasedEnergy ?? 0)])) },
						{ category: "Total emissions Scope 2", ...Object.fromEntries(years.map(year => [yearHeaderValues[year], this.formatCellValue(objectArray.find(obj => obj.year === year)?.purchasedEnergy ?? 0)])), isTotal: true },

						{ category: "Scope 3 - indirect emissions goods and services", isCategory: true, isTotal5: true },
						{ category: "• Upstream Transportation and Distribution​", ...Object.fromEntries(years.map(year => [yearHeaderValues[year], this.formatCellValue(objectArray.find(obj => obj.year === year)?.upstreamTransportationAndDistribution ?? 0)])) },
						{ category: "• Waste Generated in Operations", ...Object.fromEntries(years.map(year => [yearHeaderValues[year], this.formatCellValue(objectArray.find(obj => obj.year === year)?.wasteGeneratedInOperations ?? 0)])) },
						{ category: "• Business Travel", ...Object.fromEntries(years.map(year => [yearHeaderValues[year], this.formatCellValue(objectArray.find(obj => obj.year === year)?.businessTravel ?? 0)])) },
						{ category: "• Purchased Goods (Packaging)", ...Object.fromEntries(years.map(year => [yearHeaderValues[year], this.formatCellValue(objectArray.find(obj => obj.year === year)?.purchasedGoodsPackaging ?? 0)])) },
						{ category: "• Downstream Transportation and Distribution", ...Object.fromEntries(years.map(year => [yearHeaderValues[year], this.formatCellValue(objectArray.find(obj => obj.year === year)?.downstreamTransportationAndDistribution ?? 0)])) },
						{category: "Total emissions Scope 3", ...Object.fromEntries(years.map(year => {
							let value = totalScope3[yearHeaderValues[year]]
							return [yearHeaderValues[year], this.formatCellValue(value ?? 0)] 
						})),
						isTotal: true
						},

						{category: "Grand Total", ...Object.fromEntries(years.map(year => {
							let value = grandTotal[yearHeaderValues[year]]
							return [yearHeaderValues[year], this.formatCellValue(value ?? 0)]
						})), isTotal: true
						},
						{ category: "", },
						{ category: "CO2 per employee ", ...co2PerEmployee, isTotal: true },
						{ category: "CO2 per revenue (per Million EUR)", ...co2PerRevenue, isTotal: true }
					]
					const maxPartnerCount = Math.max(...result.map(r => (r?.partners?.distributionPartners?.length) || 0))
					this.formattedTableData = [
						{ category: this.questions[1].name, isCategory: true, isTotal1: true },
						...Array.from({ length: 10 }, (_, idx) => ({ category: `• ${this.questions[idx + 2].name}`, ...Object.fromEntries(years.map((year) => [yearHeaderValues[year], this.formatCellValue(this.getResultForYear(result, year)?.answers?.[idx + 2])])) })),
						{ category: "Total CO2 Emission from Energy Consumption", ...Object.fromEntries(years.map((year) => [yearHeaderValues[year], this.formatCellValue(Math.round(this.resolveCategoryTotals(this.getResultForYear(result, year))[0] ?? 0))])), isTotal: true },
						{category: this.questions[12].name,isCategory:true,isTotal2:true},
						...Array.from({ length: 10 }, (_, idx) => ({ category: `• ${this.questions[idx+13].name}`, ...Object.fromEntries(years.map((year) => [yearHeaderValues[year], this.formatCellValue(this.getResultForYear(result, year)?.answers?.[idx+13])])) })),
						{category:"Total CO2 Emission from Business Trip",...Object.fromEntries(years.map((year)=>[yearHeaderValues[year],this.formatCellValue(Math.round(this.resolveCategoryTotals(this.getResultForYear(result, year))[1] ?? 0))])),isTotal:true},
						{category: this.questions[23].name,isCategory:true,isTotal3:true},
						...Array.from({ length: 7 }, (_, idx) => ({ category: `• ${this.questions[idx+24].name}`, ...Object.fromEntries(years.map((year) => [yearHeaderValues[year], this.formatCellValue(this.getResultForYear(result, year)?.answers?.[idx+24])])) })),
						{
							category: "Total CO2 Emission from Shipping Ingoing",
							...Object.fromEntries(years.map((year) => {
								const record = this.getResultForYear(result, year)
								const value = this.resolveCategoryTotals(record)[2] ?? 0
								return [yearHeaderValues[year], this.formatCellValue(record?.partners ? value : Number(value).toFixed(2))]
							})),
							isTotal: true
						},
						{category: this.questions[31].name,isCategory:true,isTotal4:true},
						...Array.from({ length: 7 }, (_, idx) => ({ category: `• ${this.questions[idx+32].name}`, ...Object.fromEntries(years.map((year) => [yearHeaderValues[year], this.formatCellValue(this.getResultForYear(result, year)?.answers?.[idx+32])])) })),
						{
							category: "Total CO2 Emission from Shipping Outgoing",
							...Object.fromEntries(years.map((year) => {
								const record = this.getResultForYear(result, year)
								const value = this.resolveCategoryTotals(record)[3] ?? 0
								return [yearHeaderValues[year], this.formatCellValue(record?.partners ? value : Number(value).toFixed(2))]
							})),
							isTotal: true
						},
						{
							category: "Shipping from Distribution partners",
							isCategory: true,
							isTotal4: true
						},
						{
							category: "• What percentage of the facility's total shipments are outgoing shipping?",
							...Object.fromEntries(years.map((year) => [
								yearHeaderValues[year],
								this.formatCellValue(this.getResultForYear(result, year)?.partners?.percentage)
							]))
						},
						{
							category: "• Co2 emission from Distribution partners",
							isCategory: true,
							
						},
						// One row per distribution partner with asterisk in front of the name
						...Array.from({ length: maxPartnerCount }, (_, idx) => ({
							category: "\u00A0 \u00A0  \u00A0  \u00A0 ✦ " + (
								// Find a result that has a partner at index idx for the label
								result.find(r => r?.partners?.distributionPartners && r.partners.distributionPartners[idx])?.partners.distributionPartners[idx].company || "-"
							),
							...Object.fromEntries(years.map((year) => [
								yearHeaderValues[year],
								this.formatCellValue(this.getResultForYear(result, year)?.partners?.distributionPartners?.[idx]?.co2Emission)
							]))
						})),
						{
							category: "Total CO2 Emission from Distribution Partners",
							...Object.fromEntries(years.map((year) => {
								const record = this.getResultForYear(result, year)
								const value = record?.partners
									? record.partners.distributionPartners?.reduce((sum, partner) => sum + Number(partner.co2Emission), 0)
									: null
								return [yearHeaderValues[year], this.formatCellValue(value)]
							})),
							isTotal: true
						},
						{category: this.questions[39].name,isCategory:true,isTotal5:true},
						...Array.from({ length: 7 }, (_, idx) => ({ category: `• ${this.questions[idx+40].name}`, ...Object.fromEntries(years.map((year) => [yearHeaderValues[year], this.formatCellValue(this.getResultForYear(result, year)?.answers?.[idx+40])])) })),
						{
							category: "Total CO2 Emission from Facility Organization",
							...Object.fromEntries(years.map((year) => [
								yearHeaderValues[year],
								this.formatCellValue(Number(this.resolveDisplayTotals(this.getResultForYear(result, year)).facilityOrganization.toFixed(2))),
							])),
							isTotal: true,
						},
						...this.buildPackagingTableRows(result, years, yearHeaderValues),
						{category: "Grand Total", ...Object.fromEntries(years.map((year) => [yearHeaderValues[year], this.formatCellValue(grandTotalByYear[year]?.toFixed?.(2) ?? grandTotalByYear[year])])) , isTotal: true },
					]
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((reason) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		downloadCanvas() {
			var canvas = this.$refs.canvas
			var context = canvas.getContext("2d")
			var imageObj = new Image()
			let clientName = this.$store.getters["user/getUser"].clientName
			imageObj.onload = () => {
				context.drawImage(imageObj, 0, 0, 600, 600)
				context.font = "35pt Sarabun"
				context.fillStyle = "black"
				context.fillText(clientName, 285, 300, 375)
				this.downloadPng()
			}
			imageObj.src = require("../assets/emission-badge-2025.png")
		},
		downloadPng() {
			console.log(this.$refs.canvas)
			//this.$refs.score.classList.remove("d-none")const scale = 3
			const node = this.$refs.canvas
			let clientName = this.$store.getters["user/getUser"].clientName
			let contentHeight = 600
			let contentWidth = 600
			let newWidth = 600
			let newHeight = 600
			var scale = Math.min(
				node.offsetWidth / contentWidth,
				node.offsetHeight / contentHeight
			)
			const style = {
				transform: "scale(" + scale + ")",
				transformOrigin: "top left",
				width: newWidth + "px",
				height: newHeight + "px",
				opacity: "100%",
				position: "relative",
			}

			const param = {
				height: node.offsetHeight * scale,
				width: node.offsetWidth * scale,
				style,
			}
			domtoimage.toPng(this.$refs.canvas, param).then(function(dataUrl) {
				var link = document.createElement("a")
				link.download = "orixe-esg-" + clientName.replace(/[^a-z0-9]/gi, "_").toLowerCase() + ".png"
				link.href = dataUrl
				link.click()
			})
			//this.$refs.score.classList.add("d-none")
		},
		shouldDisplayQuestion(index) {
			const question = this.questions?.[index]
			if (!question) return false
			if (question.dependencyQuestionID == null) {
				return true
			}
			const dependencyIndex = question.dependencyQuestionID
			const answer = this.answers?.[dependencyIndex]
			if (!answer) return false
			if (question.dependencyQuestionValue.includes(answer)) {
				return true
			}
			if (Array.isArray(answer)) {
				return answer.some((element) =>
					question.dependencyQuestionValue.includes(element)
				)
			}
			return false
		},
		usesDistributionPartners() {
			const partners = this.emission?.partners?.distributionPartners
			return Array.isArray(partners) && partners.length > 0
		},
		shouldShowDetailedRow(index) {
			if (index >= 23 && index <= 38 && this.usesDistributionPartners()) {
				return false
			}
			const question = this.questions?.[index]
			if (!question) return false
			if (question.type === "spacer") {
				return true
			}
			return this.shouldDisplayQuestion(index)
		},
		formatDetailedAnswer(index) {
			const question = this.questions?.[index]
			const value = this.answers?.[index]
			if (value === null || value === undefined || value === "") {
				return "-"
			}
			const percentageTypes = [
				"percentageanswer",
				"percentageshippingin",
				"percentageshippingout",
			]
			if (question && percentageTypes.includes(question.type)) {
				return `${value}%`
			}
			return value
		},
		formatDetailedValue(value) {
			if (value === null || value === undefined || value === "") {
				return "-"
			}
			return value
		},
		titleStyle(question) {
			if (!question?.color) {
				return ""
			}
			return `background-color: ${question.color} !important; border-color: ${question.color} !important`
		},
		formatPackagingMaterialDetail(row, packaging) {
			if (!row || !packaging) {
				return "-"
			}
			const weight = this.getPackagingWeightDisplay(packaging, row)
			if (weight === "-") {
				return "-"
			}
			const recycledContent = this.formatDetailedValue(row.recycledContentPct)
			const recycledAfterUse = this.formatDetailedValue(row.recycledAfterUsePct)
			const endOfLife = row.endOfLife || packaging.defaultEndOfLife || "-"
			return `Weight: ${weight}; Recycled content at purchase: ${recycledContent}${recycledContent === "-" ? "" : "%"}; Recycled after use: ${recycledAfterUse}${recycledAfterUse === "-" ? "" : "%"}; End-of-life: ${endOfLife}`
		},
		downloadAnswers() {
			EmissionsApi.downloadEmissionsPDF(this.id, this.totalEmission)
		},
		createChart(chartId, chartData) {
			new Chart(document.getElementById(chartId), {
				type: "pie",
				data: chartData,
				options: {
					responsive: true,
					maintainAspectRatio: false,
				},
			})
		},
		goToSuppliers() {
			this.$router.push({ path: "/emissions", query: { maketrue: true }, })
		},
	},
}
</script>
<style>
.yourscorebtn1 {
	position: absolute;
	top: 0;
	left: 60;
	width: 200px;
	margin-left: 800px;
}

@media (min-width: 1900px) {
	.yourscorebtn1 {
		position: absolute;
		top: 0;
		left: 60;
		width: 200px;
		margin-left: 1400px;
	}
}
@media (max-width: 1263px) {
	.yourscorebtn1 {
		position: absolute;
		top: 0;
		left: 60;
		width: 200px;
		margin-left: 500px;
	}
}
.title-enhanced {
  font-size: 1.6rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
  position: relative;
  display: inline-block;
  padding-bottom: 8px;
}

.highlight {
  color: #2e7d32; /* Green tone */
  text-decoration: underline;
}

.badge-image {
  transition: transform 0.3s ease-in-out;
}

.badge-image:hover {
  transform: scale(1.1);
}

.download-btn {
  border-radius: 25px;
  font-weight: bold;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
}

.download-btn:hover {
  transform: scale(1.05);
}

.emissions-results-main {
	background-color: #eeeeee !important;
}

.emissions-results-main > .v-main__wrap {
	background-color: #eeeeee !important;
}

.emissions-results-main > .container.mb-0.pb-0 {
	background-color: transparent !important;
}

.emissions-results-container {
	background-color: transparent !important;
	margin-top: 20px;
}

.emissions-results-container .contentRow .container,
.emissions-results-container .contentRow .v-container {
	background-color: transparent !important;
	padding-left: 0;
	padding-right: 0;
	max-width: 100%;
}

.emissions-results-container > .contentRow {
	margin: 0 !important;
}

.emissions-results-container > .contentRow + .contentRow {
	margin-top: 20px !important;
}

.emissions-results-container > .contentRow.emissions-key-indicators-row {
	margin-top: 20px !important;
}

.emissions-results-container > .contentRow.emissions-title-row {
	padding-top: 12px;
	padding-bottom: 12px;
}

.emission-badge-canvas {
	position: fixed;
	left: -9999px;
	top: 0;
	width: 600px;
	height: 600px;
	overflow: hidden;
	pointer-events: none;
	opacity: 0;
}
</style>
